// extracted by mini-css-extract-plugin
export default {"root":"yExzT4BijMgxaaFZsxmo","number":"scQRVE1vp8X_obQcOHug"};